import * as React from "react";
import { forwardRef } from "react";
const SvgHyperFlowAlerts = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#C7FF4F", d: "M14.83 11.94 8.744.738a1.411 1.411 0 0 0-2.48 0L.178 11.94a1.41 1.41 0 0 0 1.24 2.1H13.59a1.41 1.41 0 0 0 1.24-2.082zM6.943 3.521a.614.614 0 0 1 1.227 0v5.26a.614.614 0 1 1-1.227 0zm.613 8.7a.79.79 0 1 1 0-1.58.79.79 0 0 1 0 1.58" }));
const ForwardRef = forwardRef(SvgHyperFlowAlerts);
export { ForwardRef as ReactComponent };
